import useTaskStore from '../store/taskStore'
import usePracticeStore from '../store/practiceStore'

// Semplici selector — i dati vivono nello store, zero fetch aggiuntivi
export const useLiveTasks              = () => useTaskStore(s => s.tasks)
export const useLiveScadenze           = () => useTaskStore(s => s.scadenze)
export const useLiveBlocchi            = () => useTaskStore(s => s.blocchi)
export const useLivePractices          = () => usePracticeStore(s => s.practices)
export const useLivePracticeDocuments  = () => usePracticeStore(s => s.documents)
